export default "__VITE_ASSET__B$fIrjsl__"